import * as z from "zod";
import { null as zNull } from "zod";

export const ManagedMerchantSchema = z.object({
  teamId: z.string(),
  accountId: z.string(),
  name: z.string(),
  storeUrl: z.string(),
  /** Brand-kit logo when the merchant uploaded one */
  logoUrl: z.string().nullable(),
  widget_slug: z.string(),
  portal: z.object({
    domain: z.string().nullish(),
    pathPrefix: z.string().nullish(),
  }),
});

export type ManagedMerchant = z.infer<typeof ManagedMerchantSchema>;

export const getManagedMerchants = {
  name: "getManagedMerchants" as const,
  input: zNull(),
  output: z.object({ merchants: z.array(ManagedMerchantSchema) }),
};
